export enum ApplicationStatus {
    //preparing = "preparing", // if group application (before other group members accepted)
    pending = "pending",
    accepted = "accepted",
    rejected = "rejected",
    withdrawn = "withdrawn", // if application/request send, but neither accepted nor rejected
    cancelled = "cancelled", // if application/request was cancelled after acceptance
}
export enum ApplicationType {
    announcer_application = "announcer_application",
    provider_request = "provider_request",
}

export const APPLICATION_DEFAULT_STATUS = ApplicationStatus.pending;
export const APPLICATION_DEFAULT_TYPE = ApplicationType.announcer_application;
export const APPLICATION_STATUS: string[] = Object.values(ApplicationStatus);
export const APPLICATION_TYPES: string[] = Object.values(ApplicationType);
